import { render, staticRenderFns } from "./HotelPrepositionsPhone.vue?vue&type=template&id=e5f243d6&"
import script from "./HotelPrepositionsPhone.vue?vue&type=script&lang=js&"
export * from "./HotelPrepositionsPhone.vue?vue&type=script&lang=js&"
import style0 from "./HotelPrepositionsPhone.vue?vue&type=style&index=0&lang=scss&scope=app%2Fassets%2Fstylesheets%2Fcomponents%2Ftips-phone&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports